import DomHelper from "./../dom/DomHelper"
import EventTarget from "./../events/EventTarget"

/**
 * @constructor
 */
const Component = function () {
  EventTarget.call(this)
  this.dom_ = new DomHelper()
}
Component.prototype = new EventTarget()

Component.prototype.createDom = function () {}

Component.prototype.render = function (container) {
  if (!this.element_) {
    this.createDom()
  }

  container.appendChild(this.element_)

  this.addEventListeners()
}

Component.prototype.getElement = function () {
  /*if (!this.element_) {
    this.createDom()
  }*/
  return this.element_
}

Component.prototype.destroy = function () {
  if (this.element_) {
    if (this.element_.parentNode)
      this.element_.parentNode.removeChild(this.element_)
  }
  delete this.element_
}

Component.prototype.addEventListeners = function(){}

export default Component
